import React from 'react';
import { observer } from 'mobx-react';

import { groupIcon, playersIcon, professionalIcon } from '../../../../../utils/icons';

import styles from './PreferencesConditions.module.scss';

type Props = {
    filter: {
        type: 'players' | 'coaches',

        preference: {
            court: string[],
            play: string[],
            training: string[],
        },
    },
    onChange: (filter: any) => void,
};

export default observer(function PreferencesConditions({ filter, onChange }: Props) {
    return (
        <div className={styles.container}>
            {filter.type === 'players' && (
                <>
                    <div className="d-flex justify-content-center">
                        <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: 14 }}>Play Preference</h3>
                    </div>

                    <div className="d-flex flex-row">
                        <div
                            className={styles.item}
                            style={{
                                opacity: filter.preference.play.includes('single') ? 1 : 0.5,
                            }}
                            onClick={() => {
                                if (filter.preference.play.includes('single')) {
                                    if (filter.preference.play.length > 1) {
                                        filter.preference.play = filter.preference.play.filter(type => type !== 'single');
                                    }
                                } else {
                                    filter.preference.play.push('single');
                                }

                                onChange(filter);
                            }}
                            role="presentation"
                        >
                            <div className="icon" style={{ backgroundImage: `url(${playersIcon})` }}/>
                            <div className="icon-text">Singles</div>
                            <div className="icon-small-text">&nbsp;</div>
                        </div>

                        <div
                            className={styles.item}
                            style={{
                                opacity: filter.preference.play.includes('double') ? 1 : 0.5,
                            }}
                            onClick={() => {
                                if (filter.preference.play.includes('double')) {
                                    if (filter.preference.play.length > 1) {
                                        filter.preference.play = filter.preference.play.filter(type => type !== 'double');
                                    }
                                } else {
                                    filter.preference.play.push('double');
                                }

                                onChange(filter);
                            }}
                            role="presentation"
                        >
                            <div className="icon" style={{ backgroundImage: `url(${groupIcon})` }}/>
                            <div className="icon-text">Doubles</div>
                            <div className="icon-small-text">&nbsp;</div>
                        </div>

                        <div
                            className={styles.item}
                            style={{
                                opacity: filter.preference.play.includes('tournament') ? 1 : 0.5,
                            }}
                            onClick={() => {
                                if (filter.preference.play.includes('tournament')) {
                                    if (filter.preference.play.length > 1) {
                                        filter.preference.play = filter.preference.play.filter(type => type !== 'tournament');
                                    }
                                } else {
                                    filter.preference.play.push('tournament');
                                }

                                onChange(filter);
                            }}
                            role="presentation"
                        >
                            <div className="icon" style={{ backgroundImage: `url(${professionalIcon})` }}/>
                            <div className="icon-text">Tournament</div>
                            <div className="icon-small-text">&nbsp;</div>
                        </div>
                    </div>
                </>
            )}

            {filter.type === 'coaches' && (
                <>
                    <div className="d-flex justify-content-center">
                        <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: 14 }}>Training Conditions</h3>
                    </div>

                    <div className="d-flex flex-row">
                        <div
                            className={styles.item}
                            style={{
                                opacity: filter.preference.training.includes('individual') ? 1 : 0.5,
                            }}
                            onClick={() => {
                                if (filter.preference.training.includes('individual')) {
                                    if (filter.preference.training.length > 1) {
                                        filter.preference.training = filter.preference.training.filter(type => type !== 'individual');
                                    }
                                } else {
                                    filter.preference.training.push('individual');
                                }

                                onChange(filter);
                            }}
                            role="presentation"
                        >
                            <div className="icon" style={{ backgroundImage: `url(${playersIcon})` }}/>
                            <div className="icon-text">Individual</div>
                            <div className="icon-small-text">&nbsp;</div>
                        </div>

                        <div
                            className={styles.item}
                            style={{
                                opacity: filter.preference.training.includes('group') ? 1 : 0.5,
                            }}
                            onClick={() => {
                                if (filter.preference.training.includes('group')) {
                                    if (filter.preference.training.length > 1) {
                                        filter.preference.training = filter.preference.training.filter(type => type !== 'group');
                                    }
                                } else {
                                    filter.preference.training.push('group');
                                }

                                onChange(filter);
                            }}
                            role="presentation"
                        >
                            <div className="icon" style={{ backgroundImage: `url(${groupIcon})` }}/>
                            <div className="icon-text">Group</div>
                            <div className="icon-small-text">&nbsp;</div>
                        </div>

                        <div
                            className={styles.item}
                            style={{
                                opacity: filter.preference.training.includes('professional') ? 1 : 0.5,
                            }}
                            onClick={() => {
                                if (filter.preference.training.includes('professional')) {
                                    if (filter.preference.training.length > 1) {
                                        filter.preference.training = filter.preference.training.filter(type => type !== 'professional');
                                    }
                                } else {
                                    filter.preference.training.push('professional');
                                }

                                onChange(filter);
                            }}
                            role="presentation"
                        >
                            <div className="icon" style={{ backgroundImage: `url(${professionalIcon})` }}/>
                            <div className="icon-text">Professional</div>
                            <div className="icon-small-text">&nbsp;</div>
                        </div>
                    </div>
                </>
            )}

            <div className={styles.filterTypesContainer}>
                <div className={styles.filterTypesRow}>
                    <div
                        className={styles.filterTypesCol}
                        style={{
                            backgroundImage: `url(${require('../../assets/images/courts/types/hard.png').default})`,
                            opacity: filter.preference.court.includes('hard') ? 1 : 0.75,
                        }}
                        onClick={() => {
                            if (filter.preference.court.includes('hard')) {
                                if (filter.preference.court.length > 1) {
                                    filter.preference.court = filter.preference.court.filter(type => type !== 'hard');
                                }
                            } else {
                                filter.preference.court.push('hard');
                            }

                            onChange(filter);
                        }}
                        role="presentation"
                    >
                        <div>Hard</div>
                    </div>
                    <div
                        className={styles.filterTypesCol}
                        style={{
                            backgroundImage: `url(${require('../../assets/images/courts/types/clay.png').default})`,
                            opacity: filter.preference.court.includes('clay') ? 1 : 0.75,
                        }}
                        onClick={() => {
                            if (filter.preference.court.includes('clay')) {
                                if (filter.preference.court.length > 1) {
                                    filter.preference.court = filter.preference.court.filter(type => type !== 'clay');
                                }
                            } else {
                                filter.preference.court.push('clay');
                            }

                            onChange(filter);
                        }}
                        role="presentation"
                    >
                        <div>Clay</div>
                    </div>
                    <div
                        className={styles.filterTypesCol}
                        style={{
                            backgroundImage: `url(${require('../../assets/images/courts/types/grass.png').default})`,
                            opacity: filter.preference.court.includes('grass') ? 1 : 0.75,
                        }}
                        onClick={() => {
                            if (filter.preference.court.includes('grass')) {
                                if (filter.preference.court.length > 1) {
                                    filter.preference.court = filter.preference.court.filter(type => type !== 'grass');
                                }
                            } else {
                                filter.preference.court.push('grass');
                            }

                            onChange(filter);
                        }}
                        role="presentation"
                    >
                        <div>Grass</div>
                    </div>
                </div>
            </div>
        </div>
    );
});
